import { atomWithStorage } from 'jotai/utils'

import { LOCAL_STORAGE_KEYS } from '@/lib/storage'

export type Theme = 'dark' | 'light'

export const currentThemeAtom = atomWithStorage<Theme>(
  LOCAL_STORAGE_KEYS['okami-theme'],
  'dark',
)
